import React, { createContext } from 'react';

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);

  const changeAuthStatus = () => {
    setIsLoggedIn(!isLoggedIn);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, changeAuthStatus }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
